import React from 'react';

export default function ShareholderItem({icon, title, onClick}) {
    return (
        <div className="shareholder-item" onClick={onClick}>
            <img src={icon} alt={title} className="shareholder-icon" />
            <p className="shareholder-title">{title}</p>
        </div>
    );
}
